module.exports = __webpack_public_path__ + "static/media/border-top.93168d7f.svg";